module.exports = __webpack_public_path__ + "img/CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F1_Adopted_Footway.380cd741.png";